import React from "react";
import "./coach-landing.css";

export default function CoachLandingSteps() {
  const steps = [
    {
      number: "1",
      title: "Crea tu perfil profesional",
      description: "Regístrate y completa tu perfil (foto, especialidades y disponibilidad). Listo en 2 minutos."
    },
    {
      number: "2",
      title: "Diseña tu Feed",
      description: "Desde tu panel publica recetas, guías y muestras que destaquen tu trabajo y metodología."
    },
    {
      number: "3",
      title: "Conecta y recibe clientes",
      description: "Los usuarios verán tu contenido, podrán chatear contigo y contratar tus servicios directamente desde Wayo."
    },
    {
      number: "4",
      title: "Deja de pagar cuotas",
      description: "Todo lo anterior, sin cuota mensual y sin permanencia. Lo que ahorras cada mes se queda en tu negocio."
    }
  ];

  return (
    <section className="steps-section" id="como-funciona">
      <div className="container">
        <div className="steps-header">
          <div className="section-tag">Cómo funciona</div>
          <h2 className="section-title">Empieza en 5 minutos. Gratis.</h2>
          <p className="section-subtitle">Sin procesos complicados. Sin tarjeta de crédito. Sin sorpresas.</p>
        </div>
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
